import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=54544338&scoped=true&"
import script from "./Personal.vue?vue&type=script&lang=ts&"
export * from "./Personal.vue?vue&type=script&lang=ts&"
import style0 from "./Personal.vue?vue&type=style&index=0&id=54544338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54544338",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
